//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAlarmData as _getAlarmData } from '@/api/deviceOverview/alarm';
export default {
  name: "top-notice",
  data: function data() {
    return {
      isdot: true,
      //  data: list,
      data: [],
      dotval: 0,
      timer: null
    };
  },
  created: function created() {
    this.getAlarmData();
    this.timer = null;
    this.setalarm();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    setalarm: function setalarm() {
      var _this = this;

      this.timer = setInterval(function () {
        _this.getAlarmData();
      }, 30000);
    },
    getAlarmData: function getAlarmData() {
      var _this2 = this;

      _getAlarmData({
        size: 500,
        handleFlag: '0'
      }).then(function (res) {
        if (res.data.code == 200) {
          _this2.dotval = res.data.data.total;
        }
      });
    },
    toalarm: function toalarm() {
      this.$router.push('/failWarning/alarmData');
    }
  }
};